export const TIMESHEET_COLUMN_WIDTHS = Object.freeze({
  overdue: 10,
  careGroup: 130,
  siteName: 120,
  serviceName: 120,
  speciality: 120,
  name: 140,
  timesheetStatus: 110,
  startTime: 90,
  time: 120,
  breaks: 80,
  actions: 40,
});

export const TIMESHEET_ACTION_BUTTON_WIDTH = 150;

export const getTimesheetColumnWidths = ({ adminGroupsFeatureFlag, servicesFeatureFlag }) => [
  TIMESHEET_COLUMN_WIDTHS.overdue,
  ...(adminGroupsFeatureFlag ? [TIMESHEET_COLUMN_WIDTHS.careGroup] : []),
  TIMESHEET_COLUMN_WIDTHS.siteName,
  ...(servicesFeatureFlag ? [TIMESHEET_COLUMN_WIDTHS.serviceName] : []),
  TIMESHEET_COLUMN_WIDTHS.speciality,
  TIMESHEET_COLUMN_WIDTHS.name,
  TIMESHEET_COLUMN_WIDTHS.timesheetStatus,
  TIMESHEET_COLUMN_WIDTHS.startTime,
  TIMESHEET_COLUMN_WIDTHS.time,
  TIMESHEET_COLUMN_WIDTHS.breaks,
  TIMESHEET_COLUMN_WIDTHS.actions,
];

export const getTimesheetTableMinWidth = featureFlags => getTimesheetColumnWidths(featureFlags)
  .reduce((total, width) => total + width, 0);
